import { PostStatus } from '@/types/fanfic-status';
import type { FanficData } from '@/features/fanfic-page/types/fanfic';

export const getFanficStatus = (fanfic: FanficData) => {
  const postStatus = fanfic['post-status'];
  if (postStatus) {
    switch (postStatus) {
      case PostStatus.COMPLETED:
        return 'Завершено';
      case PostStatus.FREEZED:
        return 'Заморожено';
      case PostStatus.IN_PROGRESS:
        return 'В процессе';
      default:
        return '—';
    }
  }
  return '—';
};
